import { useContext } from "react";
import { AuthContext, LanguageContext, WebContext } from "../../context";

export const useLanguage = () => {
  // NO HACE FALTA AÑADIR LOS IDIOMAS ACÁ, ESTE HOOK DEVUELVE TODAS LAS CLAVES CON SUS VALORES CORRESPONDIENTES DE FORMA AUTOMÁTICA
  return useContext(LanguageContext);
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export const useWeb = () => {
  return useContext(WebContext);
};
